import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectExternalProviderInvoiceUpload = createSelector(
  [(state: AppState) => state.externalProvider.invoiceUpload],
  state => state,
);
